<template>
  <g>
    <g clip-path="url(#clip0_15_987)">
      <path
        d="M19 2.00018H14.82C14.4 0.840183 13.3 0.000183105 12 0.000183105C10.7 0.000183105 9.6 0.840183 9.18 2.00018H5C3.9 2.00018 3 2.90018 3 4.00018V20.0002C3 21.1002 3.9 22.0002 5 22.0002H19C20.1 22.0002 21 21.1002 21 20.0002V4.00018C21 2.90018 20.1 2.00018 19 2.00018ZM12 2.00018C12.55 2.00018 13 2.45018 13 3.00018C13 3.55018 12.55 4.00018 12 4.00018C11.45 4.00018 11 3.55018 11 3.00018C11 2.45018 11.45 2.00018 12 2.00018ZM18 20.0002H6C5.45 20.0002 5 19.5502 5 19.0002V5.00018C5 4.45018 5.45 4.00018 6 4.00018H7V5.00018C7 6.10018 7.9 7.00018 9 7.00018H15C16.1 7.00018 17 6.10018 17 5.00018V4.00018H18C18.55 4.00018 19 4.45018 19 5.00018V19.0002C19 19.5502 18.55 20.0002 18 20.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_987">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
